import { BaseModel } from './base.model'

export class CenterOnlineLearningRepeatExamSetting extends BaseModel<CenterOnlineLearningRepeatExamSetting> {
  static DEFAULT_ATTRIBUTES = {}

  id: number
  grade: number
  source: string[]
  course: string
  centerId :number
  programId: number
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/center-online-learning-repeat-exam-setting.model.ts